module.exports = __webpack_public_path__ + "static/img/jjzb.6776608.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/jjzb.jpg
// module id = abKC
// module chunks = 1